import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ContractMeta } from '../../../helper/page-metadata';

@Component({
    selector: 'app-contract',
    template: `
        <app-list-layout-with-routing [Path]="PageMetaPath" TabLabel="Vertragsliste">
            <app-contract-list></app-contract-list>
        </app-list-layout-with-routing>
    `,
    styles: [
        `
            :host {
                display: block;
                height: 100%;
            }
        `,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContractComponent {
    PageMetaPath = ContractMeta.Path;
}
